import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { TimePicker } from '@mui/x-date-pickers/TimePicker';
import { Controller, useFormContext } from 'react-hook-form';
import { FormError } from './hook-form-error';

interface InputTimeFieldProps {
  label?: string;
  placeHolder?: string;
  name: string;
  maxLength?: number;
  multiline?: boolean;
  type?: string;
  autoFocus?: boolean;
  isAmpm?: boolean;
}

export const setValue = (value: any) => {
  const timeFormat: any = dayjs(value, 'h:mm A').format('HH:mm');
  const [hours, minutes] = timeFormat.split(':');
  return dayjs(dayjs().set('hour', hours).set('minute', minutes));
};

export const formatSiTrackTime = (time: any) => {
  const timeFormat = dayjs(time).format('hh:mm A');
  return timeFormat !== "Invalid Date" ? timeFormat : null;
};

export const FormInputTime = ({ name, label, isAmpm }: InputTimeFieldProps): any => {
  const { control } = useFormContext();

  return (
    <div className="form-group">
      <Controller
        control={control}
        name={name}
        render={({ field: { onChange, value } }) => (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <TimePicker
              slotProps={{ textField: { size: 'small', label: `${label}` } }}
              sx={{ width: '100%' }}
              value={value ? setValue(value) : null}
              onChange={(time: any) => onChange(formatSiTrackTime(time))}
              ampm={isAmpm}
            />
            <FormError name={name} />
          </LocalizationProvider>
        )}
      />
    </div>
  );
};

FormInputTime.defaultProps = {
  label: undefined,
  maxLength: undefined,
  placeHolder: undefined,
};
